import Modal from 'Shared/components/Modal/Modal'
import ServerWaitButton from 'Shared/components/ServerWaitButtonStandalone'

export default function RemoveModal({ open, onCancel, onConfirm }) {
  return (
    <Modal
      open={open}
      title="Permanently delete this selection of people"
      onCancel={onCancel}
    >
      <p className="bold red no-margin-top">
        This will permanently delete everyone selected in this audience, including all their personal data.
      </p>
      <p className="bold red no-margin-top">
        Please be sure this is what you want to do, as data is not recoverable.
      </p>
      <p className="bold red no-margin-top">
        If you just want to delete this audience, you can archive it by clicking 'Manage' above.
      </p>
      <p className="bold red no-margin-top">
        If you do proceed, this will have the following effects:
      </p>
      <ul>
        <li>Deleted people's personal data will be removed</li>
        <li>Deleted people will not be able to reply to text messages, or WhatsApps, or surveys they've been sent</li>
      </ul>
      <p className='no-margin-bottom'>
        If you wish to recover a deleted person, you will need to upload their data again, with the same membership number.
      </p>
      <div className="row">
        <ServerWaitButton
          className="button primary margin-top update-subscription-button"
          onClick={onConfirm}
        >
          Confirm
        </ServerWaitButton>
      </div>
    </Modal>
  )
}
